var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultUserImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F1EEFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5837_7672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24548 48.8629C8.24548 40.1619 15.299 33.1084 23.9999 33.1084C32.7009 33.1084 39.7544 40.1619 39.7544 48.8629H8.24548Z",
    fill: "#7257F0",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 33.1087C28.6507 33.1087 32.421 29.3385 32.421 24.6877C32.421 20.0368 28.6507 16.2666 23.9999 16.2666C19.3491 16.2666 15.5789 20.0368 15.5789 24.6877C15.5789 29.3385 19.3491 33.1087 23.9999 33.1087Z",
    fill: "#7257F0",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5837_7672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(7 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserImage);
export default __webpack_public_path__ + "static/media/DefaultUserImage.04a97a04075233bb4ec389881d1dbf62.svg";
export { ForwardRef as ReactComponent };